import { render, staticRenderFns } from "./DecimalField.vue?vue&type=template&id=10f75c3e&"
import script from "./DecimalField.vue?vue&type=script&lang=js&"
export * from "./DecimalField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports